import { withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button } from '#shared/components/UI';
import { InvoicesSearchParams } from '../types';
import useInvoicesSearchFormConfig from './useInvoicesSearchFormConfig';
import styles from './InvoicesSearchForm.module.scss';

const cn = withStyles(styles);

export type InvoicesSearchFormProps = {
  /** The keyword currently in the URL — the form seeds and re-seeds from it. */
  searchParams: InvoicesSearchParams;
  onSearch: (searchParams: InvoicesSearchParams) => void;
};

export default function InvoicesSearchForm({ searchParams, onSearch }: InvoicesSearchFormProps) {
  const { t: tButtons } = useTranslation('translations', { keyPrefix: 'Shared.Buttons' });
  const { ctx, renderFormElements } = useInvoicesSearchFormConfig({ initialValues: searchParams, onSubmit: onSearch });

  return (
    // A real <form>, so Enter submits the one keyword field it contains.
    <form className={cn('form')} onSubmit={ctx.handleSubmit}>
      <div className={cn('field')}>{renderFormElements()}</div>

      <Button id="search-invoice" type="submit" size="small" colorScheme="primary">
        {tButtons('search', { defaultValue: 'Search' })}
      </Button>
    </form>
  );
}
